import publicPages from '@/content/publicPages';

// Setzt Title, Description, Robots, Canonical und Open Graph passend zur Route.
// Die vorgerenderten Seiten (scripts/prerender-public.js) liefern dieselben Tags
// schon im statischen HTML aus; hier werden sie beim Navigieren in der SPA aktualisiert.

const { site } = publicPages;
const SITE_URL = (process.env.VUE_APP_FRONTEND_URL || site.url).replace(/\/+$/, '');
const INDEXABLE = process.env.VUE_APP_MODE === 'production';

function setMeta(key, value, attr = 'name') {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!href) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function applySeo(route) {
  const seo = (route.meta && route.meta.seo) || null;
  const title = seo ? seo.title : site.name;
  const description = seo ? seo.description : site.description;
  const url = seo ? SITE_URL + (seo.path || route.path) : null;

  document.title = title;
  setMeta('description', description);
  setMeta('robots', INDEXABLE && seo && seo.index !== false ? 'index, follow' : 'noindex, nofollow');
  setMeta('og:title', title, 'property');
  setMeta('og:description', description, 'property');
  if (url) setMeta('og:url', url, 'property');
  setCanonical(url);
}
